import type { VmFontPackPoolInfoDto } from '@/types/dtos/vm/vm-font-pack.dto';

export function formatVmFontPackTooltip(fontPack: VmFontPackPoolInfoDto): string {
  if (!fontPack.known) {
    return `Font pack unknown — expected ${fontPack.expectedVersion}. Pause/resume or wait for the next sync.`;
  }

  const installedAt = fontPack.installedAt
    ? new Date(fontPack.installedAt).toLocaleString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : 'unknown date';

  const installedLabel = `${fontPack.installedVersion} (installed ${installedAt})`;
  if (fontPack.upToDate) {
    return `Font pack ${installedLabel} — up to date`;
  }

  return `Font pack ${installedLabel} — outdated (expected ${fontPack.expectedVersion})`;
}

export function formatVmFontPackEventMessage(event: {
  message?: string;
  metadata?: Record<string, unknown>;
}): string | undefined {
  if (event.message) {
    return event.message;
  }

  const version = typeof event.metadata?.version === 'string' ? event.metadata.version : undefined;
  const previousVersion =
    typeof event.metadata?.previousVersion === 'string' ? event.metadata.previousVersion : undefined;
  if (version && previousVersion) {
    return `Updated from ${previousVersion} to ${version}`;
  }
  if (version) {
    return `Updated to ${version}`;
  }

  return undefined;
}
